import { Component, OnInit, Input } from '@angular/core';
import { GoogleAnalyticsService } from '../../google-analytics.service';

@Component({
  selector: 'app-merch-collection',
  templateUrl: './merch-collection.component.html',
  styleUrls: ['./merch-collection.component.css']
})
export class MerchCollectionComponent implements OnInit {
  @Input() data;
  @Input() category;

  constructor(private gs: GoogleAnalyticsService) { }

  ngOnInit() {
  }

  onClick(itemName) {
    this.gs.event('view_item', 'engagement', 'click', itemName);
  }

}
